module.exports = __webpack_public_path__ + "img/Silver III.8e182921.png";